<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-lg-3">
    <div class="row">
      <div class="col-5 col-md-4 col-lg-3 d-flex justify-content-start">
        <span class="">Date:</span>
      </div>
      <div class="col-7 col-md-8 col-lg-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0">
        <span class="itemCreated">
          {{itm.dateForBal}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-lg-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Float Balance:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{itm.floatBalance | number}}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-lg-5">
    <div class="row">
      <div class="col-4 col-xl-3 d-flex justify-content-start">
        <span class="">Station:</span>
      </div>
      <div class="col-8 col-xl-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{itm.stationName}}
        </span>
      </div>
    </div>
  </div>
</div>
